import { Injectable } from '@angular/core';
import { OpportunityClient } from '../web-api-client';

@Injectable({
  providedIn: 'root'
})
export class OpportunitiesService {

  constructor(private opportunityClient : OpportunityClient) { 
  }

  async getOpportunitiesBySearchingId(id,page: number, pageSize: number){
    return await this.opportunityClient.getOpportunitiesBySearchingId(id,page,pageSize).toPromise()
  }
}
